import { useLoanApplication } from '@axo/shared/data-access/hooks';
import {
  ApplicationDataNumberField,
  ApplicationDataNumberFieldProps,
} from './ApplicationDataNumberField';
import { useCallback } from 'react';
import { currencyFormatter } from '@axo/shared/util/formatters';

export const ApplicationDataCurrencyField: React.FC<
  ApplicationDataNumberFieldProps
> = (props) => {
  const { data: applicationData } = useLoanApplication(props.applicationID);
  const currency = applicationData?.Currency;

  const formatter = useCallback(
    (value: unknown) => {
      if (!currency) return String(value);

      const amount = Number(value);
      if (amount === 0 || isNaN(amount)) return '-';

      return currencyFormatter(amount, currency, 0);
    },
    [currency],
  );

  return <ApplicationDataNumberField formatter={formatter} {...props} />;
};
